// AUTO-GENERATED by tools/generate-parallel.mjs --world 11. Do not edit by hand.
// Regenerate with: node tools/generate-parallel.mjs --world 11
// W11 (Keep) — post-launch expansion, locked-tile mechanic.
// // Charged tile of matching color unlocks adjacent locked. d=6-7 band.
import type { LevelDef } from '@tessera/engine';

export const WORLD_11_GENERATED: LevelDef[] = [
  // d*=6  branching=11.22  D=0.011  tiles=12
  {
    id: 'w11-l01',
    world: 11,
    index: 1,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 0, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 0 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 0 },
    { coord: { q: 1, r: 2 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: -3, r: 0 }, color: 1 },
    { coord: { q: -3, r: 2 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: 3, r: -3 }, color: 2 },
    { coord: { q: 3, r: -2 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: 0, r: 3 }, color: 3 },
    { coord: { q: 3, r: -1 }, color: 3, state: { kind: 'locked', key: 3 } },
    ],
  },
  // d*=6  branching=16.07  D=0.063  tiles=12
  {
    id: 'w11-l02',
    world: 11,
    index: 2,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: -1, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -1 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: 1, r: 2 }, color: 0 },
    { coord: { q: 2, r: -3 }, color: 1 },
    { coord: { q: 1, r: -3 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: 3, r: -3 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: 3, r: -2 }, color: 2 },
    { coord: { q: -3, r: 0 }, color: 3, state: { kind: 'locked', key: 3 } },
    { coord: { q: -3, r: 3 }, color: 3 },
    ],
  },
  // d*=6  branching=13.38  D=0.088  tiles=12
  {
    id: 'w11-l03',
    world: 11,
    index: 3,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 1, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: -1, r: 3 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: -2, r: -1 }, color: 2 },
    { coord: { q: -1, r: -2 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: 3, r: -1 }, color: 3 },
    { coord: { q: 3, r: 0 }, color: 3, state: { kind: 'locked', key: 3 } },
    ],
  },
  // d*=7  branching=14.14  D=0.371  tiles=12
  {
    id: 'w11-l04',
    world: 11,
    index: 4,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: 0, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 2 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 0 },
    { coord: { q: 1, r: -3 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: 1, r: 2 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: -3, r: 3 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: -3, r: 0 }, color: 2 },
    { coord: { q: 3, r: -3 }, color: 3, state: { kind: 'locked', key: 3 } },
    { coord: { q: 3, r: -1 }, color: 3 },
    ],
  },
  // d*=7  branching=15.81  D=0.377  tiles=14
  {
    id: 'w11-l05',
    world: 11,
    index: 5,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: -3, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 1 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: 3, r: -1 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: -3, r: 2 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 1 },
    { coord: { q: -2, r: 3 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: 0, r: -3 }, color: 2 },
    { coord: { q: 2, r: -3 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: 1, r: -3 }, color: 3 },
    { coord: { q: 3, r: -2 }, color: 3, state: { kind: 'locked', key: 3 } },
    ],
  },
  // d*=7  branching=12.04  D=0.394  tiles=12
  {
    id: 'w11-l06',
    world: 11,
    index: 6,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: -2, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -3 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: 2, r: -3 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: -3, r: 2 }, color: 1 },
    { coord: { q: 0, r: -3 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: -1, r: -2 }, color: 2 },
    { coord: { q: 1, r: 2 }, color: 3 },
    { coord: { q: 0, r: 3 }, color: 3, state: { kind: 'locked', key: 3 } },
    ],
  },
  // d*=7  branching=17.70  D=0.413  tiles=13
  {
    id: 'w11-l07',
    world: 11,
    index: 7,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: 1, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 1 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: 3, r: -1 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 2 },
    { coord: { q: -3, r: 1 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: 2, r: -3 }, color: 3 },
    { coord: { q: 1, r: -3 }, color: 3, state: { kind: 'locked', key: 3 } },
    ],
  },
  // d*=7  branching=13.51  D=0.428  tiles=12
  {
    id: 'w11-l08',
    world: 11,
    index: 8,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: 2, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 2 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: -1, r: -2 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: 1, r: -3 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 2 },
    { coord: { q: 2, r: 1 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: 3, r: -2 }, color: 3 },
    { coord: { q: 3, r: -1 }, color: 3, state: { kind: 'locked', key: 3 } },
    ],
  },
  // d*=7  branching=15.65  D=0.442  tiles=12
  {
    id: 'w11-l09',
    world: 11,
    index: 9,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: -3, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 1 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -3 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: -2, r: 3 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: -3, r: 2 }, color: 1 },
    { coord: { q: 2, r: 1 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: 0, r: 3 }, color: 2 },
    { coord: { q: -3, r: 0 }, color: 3 },
    { coord: { q: -1, r: -2 }, color: 3, state: { kind: 'locked', key: 3 } },
    ],
  },
  // d*=7  branching=20.33  D=0.452  tiles=12
  {
    id: 'w11-l10',
    world: 11,
    index: 10,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: 3, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 0 }, color: 3, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 0, state: { kind: 'locked', key: 0 } },
    { coord: { q: 2, r: 1 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 1, state: { kind: 'locked', key: 1 } },
    { coord: { q: 3, r: -3 }, color: 2, state: { kind: 'locked', key: 2 } },
    { coord: { q: 3, r: -1 }, color: 2 },
    { coord: { q: 1, r: -3 }, color: 3 },
    { coord: { q: -3, r: 2 }, color: 3, state: { kind: 'locked', key: 3 } },
    ],
  },
];
